import { z } from 'zod';

export type CreateTenantPayload = z.infer<typeof createTenantPayloadSchema>;

export const createTenantPayloadSchema = z.object({
  name: z.string().min(1),
  metadata: z.record(z.string(), z.unknown()).optional(),
});
